<template>
  <div class="body">
    <div class="news">
      <div class="title">
        <p>新着情報</p>
      </div>
      <div class="news-title">
        <span v-if="newss.id==3">
          <p>J-DIRECT BOX</p>
          <p>海外で日本のIPを取得できるVPNルーター内蔵SmartTV BOX</p>
        </span>
        <span v-if="newss.id==2">
          <p>J-DIRECT BOX及びJ-DIRECT日本VPNプロバイダー接続サービス</p>
          <p>海外及び日本販売代理店募集開始のお知らせ</p>
        </span>
        <span v-else>
          <p>{{newss.title}}</p>
        </span>
      </div>
      <div class="new-foot">
        <span>
          DIRECT PROVIDER（ダイレクト・プロバイダー）
        </span>
        <div class="news-date">
          {{newss.date}}
        </div>
      </div>
    </div>
    <div class="news-msg">
      <div class="msg">
        <p>{{newss.msg1}}</p>
        <p>{{newss.msg2}}</p>
      </div>
      <div class="other" v-if="newss.id==3">
        <div class="other-title">
          <span>DIRECT PROVIDER（ダイレクト・プロバイダー）</span>
        </div>
        <div class="other-content">
          <span>
            海外専用回線、日本のVPNプロバイダーサービスを提供するDIRECT PROVIDER CO.,LTD（所在地：香港、資本金HK$300万）は、 海外にいても日本のIP環境でインターネット接続ができるVPNルーターを内蔵する「スマートTV BOX」（ AndroidTV ™️⒎1 OS標準搭載）を2020年11月1日から世界中の在住日本人に向けて発売します。
            <br />【URL】http://j-direct.com/
          </span>
        </div>
      </div>
      <div class="other" v-if="newss.id==2">
        <div class="other-title">
          <span>［募集地域］</span>
        </div>
        <div class="other-content">
          <span>
            ・ヨーロッパ<br />
            ・中東<br />
            ・ロシア<br />
            ・アジア<br />
            ・豪州、ニュージーランド<br />
            ・北米、カナダ、ハワイ<br />
            ・中南米<br />
            ・アフリカ<br />
            ・西、南、ミドルアジア各国<br />
            ・日本<br />
          </span>
        </div>
      </div>
      <div v-if="newss.id==2">
        <div class="outline">
          <div class="outline-title">
            <span>［目的］</span>
          </div>
          <div class="outline-content-two">
            ・コロナ禍で巣ごもり生活を余儀なくされている海外在住日本人に新たなエンタメを提供する。<br/>
            ・海外でビジネスを展開している個人・団体に持続可能な新規事業の機会を提供する。
          </div>
        </div>
        <div class="outline">
          <div class="outline-title">
            <span>［応募対象］</span><br />
            <span>１．海外業者</span>
          </div>
          <div class="outline-content-two">
            <span>・海外日本人向けの不動産会社</span><br />
            <span>・海外店舗を持つネット・小売事業者</span><br />
            <span>・海外日本人向け引っ越し・旅行業者</span><br />
            <span>・海外日本人向けメディア・通信業者</span><br />
            <span>・海外日本人の顧客を持つ事業者</span>
          </div>
          <div class="outline-title" style="margin-top:50px">
            <span>２．日本国内業者</span>
          </div>
          <div class="outline-content-two">
            <span>・海外引越業者</span><br />
            <span>・海外旅行、駐在、留学関連・保険業者</span><br />
            <span>・海外向けモバイル通信事業者</span><br />
            <span>・海外ビジネス、生活応援の業者、組織</span><br />
            <span>・海外日本人に関連する業者、組織</span><br />
            <span>・インターネットルートの事業者</span>
          </div>
        </div>
        <div class="outline">
          <div class="outline-title">
            <span>［条件］</span>
          </div>
          <div class="outline-content-two">
            ・対象地域に拠点を持ち、日本人の担当者が常駐していること。<br/>
            ・顧客に日本語で簡単な機器の設置説明が可能なこと。<br/>
            ・事前に簡単なインターネット回線調査等にご協力いただけること。<br/>
            ・EMSなどの海外郵送物が確実に届く事務所・私書箱等を持つこと。<br/>
            ・USD取引が可能なこと。<br/>
            ・１年以上の代理店継続ができること。
          </div>
        </div>
        <div class="outline">
          <div class="outline-title">
            <span>［収益モデル］</span>
          </div>
          <div class="outline-content-two">
            <span>・機器本体の販売の一時手数料</span><br />
            <span>・日本VPN接続サービス契約者の毎月利用料金のコミッション</span><br />
            <span>・海外日本販促活動の一時応援金とその他の収入</span><br/>
            <span>・機器は販売台数に基づき収益率を設定致します。オプション契約収益は、年間営業実績に基づいて収益率を年次見直し致します。</span>
          </div>
        </div>
        <div class="outline">
          <div class="outline-title">
            <span>［お問合せ先］</span>
          </div>
          <div class="outline-content-two">
            Eメール：info@d-provider.com<br/>
            ご興味がありましたら、まずはご気軽にお問い合わせ下さい。<br/>
            ご担当者名、社名、地域、ご連絡先を明記下さい<br/>
            各地域担当が日本語にて対応致します。
          </div>
        </div>
      </div>
      <div v-if="newss.id==3">
        <div class="outline">
          <div class="outline-title">
            <span>製品の概要</span>
          </div>
          <div class="outline-content">
            <span>
              ▶プロのアイデア　プロのデザイン　<br />
              海外駐在・海外生活の必需品「J-DIRECT BOX」。<br />
              海外にいながら、日本の「IP制限」動画コンテンツが楽しめる！
            </span>
          </div>
          <div class="outline-content-two">
            <span>
              ◎ 標準GoogleTV OS搭載、4K HDR高画質SmartTV BOX<br />
              ◎ 海外から日本IP環境で接続可能なVPNルーターを内蔵<br />
              ◎ モバイル端末も日本IP環境で接続できるWiFi機能<br />
              ◎ GooglePlay、Google Assistant、ミラーリング諸機能搭載<br />
              ◎ 海外地域情報を日本語で発信するハイブリッドキャスト
            </span>
          </div>
          <div class="outline-content-two">
            <img :src="news1">
          </div>
        </div>
        <div class="outline">
          <div class="outline-title">
            <span>開発の背景</span>
          </div>
          <div class="outline-content">
            <span>
              ▶「コロナ禍」長期化で巣ごもり生活に飽きた海外生活者に朗報！
            </span>
          </div>
          <div class="outline-content-two">
            <span>
              テレワーク勤務の普及や外出機会の減少など、「コロナ禍」の長期化は海外赴任者、海外在住者のライフスタイルに大きな影響を及ぼしています。テレビの視聴方法もすっかり変わりました。見逃したお気に入り番組をいつでも好きな時間に視聴したいというニーズが、若者層だけではなく、いまやシルバー層にも浸透しているのです。
            </span>
          </div>
          <div class="outline-content-two">
            <span>
              とはいえ、日本市場向けに配信されているテレビ番組等を海外で楽しむのは決して容易なことではありません。Amazon Prime Video(プライム・ビデオ)はもとより、ABEMA(アベマ)やNETFLIX(ネットフリックス)といった日本で有名なネット動画、テレビ配信サービスのほとんどが日本国内に配信が限定されており、海外ではサービスが受けられないのが通常だからです。
            </span>
          </div>
          <div class="outline-content-two">
            <div style="position: relative;">
              <img :src="msgBg0">
              <div class="box-inset">
                <div class="title" style="color:#3E67B2;font-size:35px;">
                  海外在住日本人のテレビ視聴のお悩みを解消！
                </div>
                <div class="min-title" style="color:#222;font-size:25px">
                  日本の動画コンテンツが海外で観られない。<br />
                  VPN設定の仕方がわからない！使いづらい！
                </div>
              </div>
            </div>
          </div>
          <div class="outline-content-two">
            <span>
              もちろん日本のIP環境で接続するVPNサーバーを利用すれば、IP制限動画やテレビ番組を見られるようにすることはできます。しかし、煩雑な利用方法や不安定なサービス、時として法的な問題がクリアできないなどハードルは高く、誰もが利用できるわけではありません。
            </span>
          </div>
          <div class="outline-content-two">
            <span>
              「J-DIRECT BOX」は、海外在住日本人向けに開発された日本VPNルーター内蔵のGoogleTV BOXです。海外赴任前や赴任中に「J-DIRECT BOX」を購入して、現地のインターネット環境で接続すると、あたかも日本にいるのと同じように、誰もが簡単にJ-DIRECT日本VPNプロバイダーサーバーに接続し、「IPアドレス制限」された日本の動画サービスやテレビ番組を簡単にお楽しみいただけます。
            </span>
          </div>
          <div class="outline-content-two">
            <span>
              さらに、「J-DIRECT BOX」には、海外在住邦人のニーズに対応したリアルな地域情報をテレビで配信する「J-NAVI」サービスもセットしています。テレビのトップ画面で現地の生活情報やビジネス関連情報をお勧めしたり、動画の再生画面で受信者がお気に入りの現地情報をプッシュ配信したりする次世代ハイブリッドキャスト機能を順次リリースしていく予定です。
            </span>
          </div>
        </div>
        <div class="outline">
          <div class="outline-title">
            <span>製品の特長</span>
          </div>
          <div class="outline-content">
            <span>
              ▶かんたん操作・豊富な機能と拡張性・お値打ち価格
            </span>
          </div>
          <div class="outline-content-two">
            <img :src="news3" />
          </div>
          <div class="outline-content-two">
            <span>
              ①業界標準仕様GoogleTV のAndroidTV7.1 OSを搭載。低コストでご自宅のテレビを最新の高機能スマートテレビに変身させます。「J-DIRECT BOX」本体には、無料のABEMA、TVer、GYAOのほか、Netflix、Amazon Prime Videoといった有料動画配信サービスのアプリがプリセットされています。日本VPN環境への接続はリモコンのJ-DIRECT専用ボタンをワンタッチするだけ！一方、「J-DIRECT BOX」本体からWiFi接続したモバイル端末でも日本のIP制限動画コンテンツが日本のIP環境でお楽しみいただけます。
            </span>
          </div>
          <div class="outline-content-two">
            <img :src="news4" />
          </div>
          <div class="outline-content-two">
            <span>
              ②GoogleTV標準セットのYouTubeやGoogle Play、NHKワールドのほか、海外でテレビ放送を受信する手順方法をガイドしたJ-DIRECTクイックスタート、海外現地日本人向けにローカル情報をテレビ配信するJ-NAVI等、独自のテレビアプリもプリセット。さらには、U-NEXT、hulu、FOD、Paravi、TELASA、DAZNなど日本の動画アプリをGoogle Playストアから追加インストールして楽しむこともできます。
            </span>
          </div>
          <div class="outline-content-two">
            <img :src="news5" />
          </div>
          <div class="outline-content-two">
            <span>
              ③「J-DIRECT BOX」本体には、GoogleTV BOX以外にVPN ルーターを内蔵し、海外で日本VPNサービスを提供する日本VPNプロバイダーサービスをセットで提供しています。BOX本体はもちろん、日本のIP環境で本体のWiFiを屋内で飛ばせば、リビングにあるテレビだけではなく寝室や子ども部屋等でも、その他のモバイル端末で日本のIP 制限動画コンテンツを面等な操作も行うことなく簡単に視聴いただけるようになります。
            </span>
          </div>
          <div class="outline-content-two">
            <img :src="news6" />
          </div>
          <div class="outline-content-two">
            <span>
              ④Google Assitant機能搭載、テレビを見ながら動画やアプリを検索、アプリの切り替えが簡単に音声で行える上、スマホの画面をミラーリング方式でテレビ画面に映し出すミラキャスト機能もビルトインされています。大画面テレビで見ることができ、家族団らんの楽しみが増します。
            </span>
          </div>
          <div class="outline-content-two">
            <img :src="news7" />
          </div>
          <div class="outline-content-two">
            <span>
              ⑤「J-DIRECT BOX」では最新のハイスペックチックを採用。2GB+16GB 大容量メモリでストレスのない高速な操作が可能。さらに、4K HDR　60fps高画質コーデックで3840×2160の超高画質解像度を実現！自然でリアルな映像を表示します。4Kテレビに合わせて、NETFLIX やYouTubeの4K動画視聴に最適！
            </span>
          </div>
          <div class="outline-content-two">
            <img :src="news8" />
          </div>
          <div class="outline-content-two">
            <span>
              ⑥「J-DIRECT」にいま初期登録していただくと、海外からの日本VPN接続プロバイダーサービスが3カ月間無料で利用できる無料体験クーポン（USD60相当）をプレゼント！　さらに、「リモコンがコントロールできないアプリも使いたい」「タブレットにしか対応していない動画配信アプリを大画面テレビで鑑賞したい」といったニーズにも対応できるように、手指の動きでテレビアプリが操作できる最新型の指マウス（販売価格USD20）をセットでプレゼントします。今年4月から提供が始まったネット同時配信のNHKプラスや、来年配信が予定されている民放のライブTV のネット同時配信を海外で受信する際に重宝するでしょう。
            </span>
          </div>
          <div class="outline-content-two">
            <img :src="news9" />
          </div>
          <div class="outline-content-two">
            <span>
              ⑦「J-DIRECT　BOX 」には海外在住邦人向け海外現地生活、ビジネス情報を発信するスマホアプリ「邦人Navi」のテレビ版ツールをプリセット。リモコン操作一つで海外受信者の所在地域の生活・ビジネス情報をメニュー画面にプッシュ配信します。さらに、今後のバージョンアップでは、視聴中の画面にお好きな現地情報をプッシュ配信する次世代ハイブリットキャスト機能の搭載も予定しています。
            </span>
          </div>
          <div class="outline-content-two">
            <img :src="news10" />
          </div>
          <div class="outline-content-two">
            <span>
              ⑧「J-DIRECT BOX」はCE、FCC認証を取得。年内には日本のTELEC認証も完了する予定です。現在、発売記念特売キャンペーン期間中。通常販売価格USD158（J-DIRECT 日本VPN接続サービス3カ月USD60、テレビもサクサク操作できる指マウスUSD20含む）のところ、海外郵送料をサービスし、USD128の特別価格でお買い求めいただけます。プレゼント分を除くとわずかUSD48。現在市販されているアマゾンのFire Tv Stick（USD49.99) やGoogleの最新製品New Chromecast with GoogleTV(USD49.99）よりもお値打ち価格です。
            </span>
          </div>
          <div class="outline-content-two">
            <img :src="news11" />
          </div>
          <div class="outline-content-two">
            <span>
              ⑨海外滞在期間の長短に関わらず、ビジネスパーソンや旅行者に根強い「VPNルーター」と「日本動画視聴」へのニーズ。これに一台で応えてくれるのが「J-DIRECT BOX」です。ホテル、マンションのWi-Fi環境があれば即利用が可能。本体とリモコンは超コンパクト設計ですので、小袋に入れてもかさばらず、収納性や携帯性に優れています。
            </span>
          </div>
          <div class="outline-content-two">
            <img :src="news12" />
          </div>
          <div class="outline-content-two">
            <span>
              ⑩製品には音声を受発信する内蔵2W スピーカー、リモートアップデート、非公式テレビアプリの外部インストール、テレビウェブブラウザーなどのアプリやその他機能も搭載され、今後ユーザーのニーズに合わせてさらに進化していきます。
            </span>
          </div>
          <div class="outline-content-two">
            <img :src="news13" />
          </div>
          <div class="outline-content-two">
            <img :src="news14" />
          </div>
        </div>
        <div class="outline" style="margin-top:50px;">
          <div class="outline-title">
            <span>製品開発・VPNサービス提供会社</span>
          </div>
          <div class="outline-content-two">
            <span>
              会社名：DIRECT PROVIDER CO., LIMITED<br />
              所在地：9/F BULKIN CENTRE 332-334 PORTLAND STREET MONGKOK KL　HONGKONG<br />
              会社設立：2016-09<br />
              URL：http://www.j-direct.com/<br />
              Email：info@d-provider.com<br />
              事業内容:１．国際間専用回線、VPNプロバイダーサービス <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              ２．通信製品の企画、開発、販売
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { msgBg0 } from '../../images/vpn/index'
import { banner, newsLogo , news1 , news2 , news3 , news4 , news5 , news6 , news7 , news8 , news9 , news10 , news11 , news12 , news13 , news14 } from '../../images/news/index'
import roundImages from '../../public-modules/round-images/index'
import news from '../../data-js/news/index'
export default {
  data () {
    return {
      msgBg0,
      banner,
      newsLogo,
      news,
      newss:[],
      news1,
      news2,
      news3,
      news4,
      news5,
      news6,
      news7,
      news8,
      news9,
      news10,
      news11,
      news12,
      news13,
      news14
      // newsList
    }
  },
  components: {
    roundImages
  },
  methods: {
  },
  mounted(){
    console.log(this.$route.query.id)
    let current = this.$route.query.id
    news.forEach(n => {
      if(n.id == current){
        this.newss = n
        return
      }
    });
    if(this.newss.length==0){
      this.newss = news[0]
    }
    
  }
}
</script>
<style scoped>
  .body{
    margin: 0 auto;
    width: 1000px;
    margin-top: 80px;
    margin-bottom: 80px;
  }
  .news{
    widows: 100%;
    padding-bottom: 69px;
    margin-bottom: 61px;
    border-bottom: 2px dashed #BDBDBD;;
  }
  .title{
    font-size: 32px;
    font-family: A-OTF Gothic MB101 Pro;
    font-weight: normal;
    color: #39D8CC;
    line-height: 53px;
  }
  .news-title{
    margin-top: 40px;
    font-size: 26px;
    font-family: middle;
    font-weight: normal;
    color: #141414;
    line-height: 40px;
  }
  .new-foot{
    margin-top: 19px;
    position: relative;
  }
  .new-foot span{
    margin-left: 8px;
    font-size: 21px;
    font-family: light;
    font-weight: normal;
    color: #141414;
    line-height: 50px;
  }
  .news-date {
    position: absolute;
    font-family: light;
    width: 130px;
    height: 30px;
    border: 1px solid #282828;
    border-radius: 4px;
    right: 0;
    bottom: 15px;
    font-size: 13px;
    font-weight: normal;
    text-align: center;
    line-height: 30px;
}
.msg{
  font-size: 22px;
  font-family: middle;
  font-weight: normal;
  color: #141414;
  line-height: 37px;
  margin-bottom: 50px;
}
.other{
  margin-bottom: 82px;
}
.other-title{
  font-size: 22px;
  font-family: middle;
  font-weight: normal;
  color: #141414;
  line-height: 52px;
}
.other-content{
  margin-top: 27px;
  font-size: 18px;
  font-family: light;
  font-weight: normal;
  color: #141414;
  line-height: 34px;
}
.outline{
  margin-bottom: 88px;
}
.outline-title{
  font-size: 30px;
  font-family: A-OTF Gothic MB101 Pro;
  font-weight: normal;
  color: #141414;
  line-height: 52px;
}
.outline-content{
  margin-top: 32px;
  font-size: 22px;
  font-family: middle;
  font-weight: normal;
  color: #141414;
  line-height: 46px;
}
.outline-content-two{
  margin-top: 33px;
  font-size: 18px;
  font-family: light;
  font-weight: normal;
  color: #141414;
  line-height: 36px;
}
.outline-content-two img{
  width: 100%;
  margin: 0 auto;
  height: auto;
  display: block;
}
.box-inset{
  position: absolute;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  top: 0;
  left: 0;
  color: #ffffff;
  padding: 0.6rem 0;
}
</style>


// WEBPACK FOOTER //
// src/components/news/index.vue